<template>
  <div :class="{home: this.$route.name === 'home', 'cheque-layout' : isCheque, 'main-layout' : !isCheque}">
    <header :class="(isCheque ? 'cheque-layout' : 'main-layout') + '__header'">
      <div class="container">
        <img class="gob-band-icon" src="@/assets/images/gob-band.svg" alt="Gob Band">
        <div :class="(isCheque ? 'cheque-layout' : 'main-layout') + '__header-bottom'">
          <div :class="(isCheque ? 'cheque-layout' : 'main-layout') + '__header-bottom-left'">
            <router-link to="/" tag="h1" :class="(isCheque ? 'cheque-layout' : 'main-layout') + '__title'">
              Prescripción de Medicamentos
            </router-link>
            <app-date-time />
          </div>
          <div :class="(isCheque ? 'cheque-layout' : 'main-layout') + '__header-bottom-right'">
            <div class="row">
              <div class="col-md-8">
                <auth-user-info :user="user" />
              </div>
              <div class="col-md-4 pt-4">
                <div style="width:200px;margin-bottom:20px;">
                  <router-link to="/auth/logout" class="logout-btn">
                    <i class="fas fa-power-off mr-2" aria-hidden="true" />Cerrar sesión
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main :class="(isCheque ? 'cheque-layout' : 'main-layout') + '__content container'">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="btn-back" :class="{visible: this.$route.name !== 'home', 'btn-back-cheque' : isCheque}" @click="goHistoryBack()">
            <i class="fas fa-arrow-left" aria-hidden="true" />
            Atrás
          </div>
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </div>
      </div>
    </main>
    <footer :class="(isCheque ? 'cheque-layout' : 'main-layout') + '__footer'">
      <div class="container">
        <span :class="(isCheque ? 'cheque-layout' : 'main-layout') + '__footer-logo'">&nbsp;</span>
      </div>
    </footer>
    <!-- <logout-modal /> -->
    <logout-modal-new />
  </div>
</template>

<script>
import AuthUserInfo from '../components/auth/AuthUserInfo';
import AppDateTime from '@/components/AppDateTime';
// import LogoutModal from '@/components/LogoutModal';

import LogoutModalNew from '@/components/LogoutModalNew';

import localStorage from '@/helpers/localStorage';

localStorage.initialize();

export default {
  name: 'MainLayout',
  components: {
    AuthUserInfo,
    AppDateTime,
    LogoutModalNew
  //  LogoutModal
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    isCheque() {
      return process.env.VUE_APP_RECETA_CHEQUE == 'true';
    },
    isFirefox() {
      return typeof InstallTrigger !== 'undefined';
    }
  },
  watch: {
    $route(to, from) {
      if (this.$store.getters.loggedIn) {
        this.$store.dispatch('checkToken')
          .then(({ data }) => {
            this.$store.dispatch('restoreUserSessionFromToken', this.$store.state.localToken);
          })
          .catch((e) => { this.$store.dispatch('logout', e); });
      }
    }
  },
  methods: {
    goHistoryBack() {
      if (this.$route.name === 'medication-requests-preview' && this.isFirefox) {
        window.history.go(-2);
      } else {
        window.history.back();
      }
    }
  }
};
</script>

<style lang="scss">

.cheque-layout {
  display: grid;
  grid-template-areas:
    "header"
    "content"
    "footer";
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
  background-color: $--app-cheque-bg-color;
  transition: .3s ease;
  &.home {
    background-color:  $--app-cheque-bg-color;
  }
  .gob-band-icon {
    width: 160px;
    position: absolute;
  }

  &__header {
    grid-area: header;
    background-color: $--app-cheque-header-bg-color !important;
  }

  &__header-bottom {
    color: $--color-black;
    display: block;
    justify-content: space-between;
    align-items: baseline;
    @media (min-width: map-get($--grid-breakpoints, "md")) {
      display: flex;
    }
  }

  &__header-bottom-left {
    margin-bottom: $--spacing-4;
  }

  &__header-bottom-right {
    .auth-user-info {

    }
  }

  &__title {
    color: $--color-black;
    font-size: $--font-size-lg;
    padding: $--spacing-6 0 0 0;
    cursor: pointer;
  }

  &__content {
    grid-area: content;
  }

  &__footer {
    grid-area: footer;
    padding: $--spacing-6 0;

    .container {
      display: flex;
      justify-content: center;
    }
  }

  &__footer-logo {
    width: 200px;
    display: block;
  }

  .main-layout__title {
    font-size: 24px;
    font-weight: 700;
    line-height: 16px;
  }
}

.main-layout {
  display: grid;
  grid-template-areas:
    "header"
    "content"
    "footer";
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
  background-color: $--app-main-bg-color;
  transition: .3s ease;
  &.home {
    background-color: $--color-dark-blue;
  }
  .gob-band-icon {
    width: 160px;
    position: absolute;
  }

  &__header {
    grid-area: header;
    background-color: $--app-header-bg-color;
  }

  &__header-bottom {
    color: $--color-white;
    display: block;
    justify-content: space-between;
    align-items: baseline;
    @media (min-width: map-get($--grid-breakpoints, "md")) {
      display: flex;
    }
  }

  &__header-bottom-left {
    margin-bottom: $--spacing-4;
  }

  &__header-bottom-right {
    .auth-user-info {

    }
  }

  &__title {
    color: $--color-white;
    font-size: $--font-size-lg;
    padding: $--spacing-6 0 0 0;
    cursor: pointer;
  }

  &__content {
    grid-area: content;
  }

  &__footer {
    grid-area: footer;
    padding: $--spacing-6 0;

    .container {
      display: flex;
      justify-content: center;
    }
  }

  &__footer-logo {
    width: 200px;
    display: block;
  }

  .main-layout__title {
    font-size: 24px;
    font-weight: 700;
    line-height: 16px;
  }
}

</style>
